import React from 'react';
import {
    FaShieldAlt,
    FaLightbulb,
    FaAward,
    FaUserCheck,
    FaRocket,
    FaHandshake,
    FaCheckCircle,
    FaLeaf,
    FaHeart,
    FaGlobe
} from 'react-icons/fa';
import SisterConcerms from '../AboutUs/SisterConcerms';
import Achievements from '../AboutUs/Achievements';
import AboutBanner from '../AboutUs/AboutBanner';

const OurCoreValues = () => {
    // ১০টি কোর ভ্যালুর সম্পূর্ণ টেক্সট এবং সামারি ডেটা
    const coreValuesData = [
        {
            title: "Integrity",
            description: "We conduct every aspect of our business with honesty, transparency, and accountability. We believe that trust is the foundation of every successful relationship with our customers, partners, employees, and stakeholders.",
            summary: "We act with honesty, transparency, and accountability.",
            icon: <FaShieldAlt />,
            themeColor: "#00afe9"
        },
        {
            title: "Innovation",
            description: "We embrace creativity, technology, and continuous improvement to develop innovative solutions that create long-term value and keep us ahead in a rapidly changing world.",
            summary: "We embrace new ideas and technology.",
            icon: <FaLightbulb />,
            themeColor: "#c004d4"
        },
        {
            title: "Excellence",
            description: "We are committed to delivering the highest standards of quality in everything we do. Through professionalism, dedication, and continuous improvement, we strive to exceed expectations and achieve outstanding results.",
            summary: "We strive for the highest standards in everything we do.",
            icon: <FaAward />,
            themeColor: "#00afe9"
        },
        {
            title: "Customer Commitment",
            description: "Our customers are at the heart of every decision we make. We are dedicated to understanding their needs, delivering exceptional experiences, and building long-term relationships based on trust and satisfaction.",
            summary: "We put our customers at the center of our decisions.",
            icon: <FaUserCheck />,
            themeColor: "#c004d4"
        },
        {
            title: "Entrepreneurship",
            description: "We encourage visionary thinking, bold ideas, and responsible risk-taking. By supporting entrepreneurs and empowering innovation, we create opportunities for sustainable business growth and long-term success.",
            summary: "We empower ideas and support business growth.",
            icon: <FaRocket />,
            themeColor: "#00afe9"
        },
        {
            title: "Collaboration",
            description: "We believe that the best results are achieved through teamwork, mutual respect, and strong partnerships. Together, we build stronger businesses and create greater value for everyone involved.",
            summary: "We believe in teamwork and shared success.",
            icon: <FaHandshake />,
            themeColor: "#c004d4"
        },
        {
            title: "Accountability",
            description: "We take ownership of our responsibilities and remain accountable for our actions, decisions, and commitments. We believe accountability drives performance, trust, and sustainable success.",
            summary: "We take responsibility for our commitments.",
            icon: <FaCheckCircle />,
            themeColor: "#00afe9"
        },
        {
            title: "Sustainability",
            description: "We are committed to building businesses that create lasting economic, social, and environmental value. Our goal is to achieve sustainable growth while making a positive contribution to society and future generations.",
            summary: "We build businesses for long-term impact.",
            icon: <FaLeaf />,
            themeColor: "#c004d4"
        },
        {
            title: "Respect",
            description: "We treat every individual with dignity, fairness, and respect. We embrace diversity, value different perspectives, and foster an inclusive workplace where everyone can thrive.",
            summary: "We value people, diversity, and inclusion.",
            icon: <FaHeart />,
            themeColor: "#00afe9"
        },
        {
            title: "Social Responsibility",
            description: "We believe that successful businesses have a responsibility to contribute to society. Through employment generation, ethical business practices, and community engagement, we strive to support the economic and social development of Bangladesh.",
            summary: "We contribute to economic and social development.",
            icon: <FaGlobe />,
            themeColor: "#c004d4"
        }
    ];

    return (
        <div style={{ fontFamily: '"Inter", sans-serif', color: '#1e293b', backgroundColor: '#f8fafc' }}>

            {/* Banner */}
            <AboutBanner
                text={"Our Core Values"}
                des={"Guiding every decision, shaping our culture, and driving sustainable growth."}
            />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '20px' }}>

                {/* Intro Section */}
                <section style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '40px',
                    maxWidth: '1440px',
                    margin: '0 auto 60px auto',
                    flexWrap: 'wrap'
                }}>
                    {/* Left Content */}
                    <div style={{ flex: '1 1 450px' }}>
                        <span style={{
                            display: 'inline-block',
                            padding: '6px 18px',
                            backgroundColor: '#e0f2fe',
                            color: '#00afe9',
                            fontSize: '0.875rem',
                            fontWeight: '700',
                            borderRadius: '50px',
                            marginBottom: '16px',
                            letterSpacing: '1px',
                            textTransform: 'uppercase'
                        }}>
                            Foundation of Our Culture
                        </span>

                        <h2 style={{
                            fontSize: '2.25rem',
                            fontWeight: '800',
                            color: '#0f172a',
                            marginBottom: '16px',
                            letterSpacing: '-0.02em',
                            lineHeight: '1.2'
                        }}>
                            Our Core Values
                        </h2>

                        <p style={{ fontSize: '1.125rem', color: '#475569', lineHeight: '1.8', margin: 0 }}>
                            At Iconic Unity Group, our core values define who we are, guide every decision we make, and shape the way we conduct business. They are the foundation of our culture and the driving force behind our commitment to excellence, innovation, and sustainable growth.
                        </p>
                    </div>

                    {/* Right Image */}
                    <div style={{ flex: '1 1 450px' }}>
                        <img
                            src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=800&q=80"
                            alt="Foundation of Our Culture"
                            style={{
                                width: '100%',
                                height: '350px',
                                objectFit: 'cover',
                                borderRadius: '16px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)'
                            }}
                        />
                    </div>
                </section>

                {/* Core Values Cards Grid */}
                <section style={{ marginBottom: '80px' }}>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        gap: '24px'
                    }}>
                        {coreValuesData.map((value, index) => (
                            <div
                                key={index}
                                style={{
                                    // বড় স্ক্রিনে ৪টি কার্ডের জন্য প্রস্থ (gap বাদ দিয়ে calc)
                                    flex: '1 1 calc(25% - 24px)',
                                    minWidth: '280px', // মোবাইল ও ট্যাবলেটে অটো রেসপন্সিভ করবে
                                    maxWidth: '360px',
                                    backgroundColor: '#ffffff',
                                    padding: '32px 24px',
                                    borderRadius: '16px',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.04)',
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    boxSizing: 'border-box'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.borderColor = value.themeColor;
                                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0, 0, 0, 0.08)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.borderColor = '#e2e8f0';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.04)';
                                }}
                            >
                                <div>
                                    {/* Top Color Accent Bar */}
                                    <div style={{
                                        width: '40px',
                                        height: '4px',
                                        backgroundColor: value.themeColor,
                                        borderRadius: '2px',
                                        marginBottom: '20px'
                                    }} />

                                    {/* Icon & Title */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                                        <div style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '12px',
                                            backgroundColor: value.themeColor === '#00afe9' ? '#e0f2fe' : '#fce7f3',
                                            color: value.themeColor,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '22px',
                                            flexShrink: 0
                                        }}>
                                            {value.icon}
                                        </div>
                                        <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a', margin: 0 }}>
                                            {value.title}
                                        </h3>
                                    </div>

                                    {/* Main Paragraph */}
                                    <p style={{ fontSize: '0.95rem', color: '#475569', lineHeight: '1.7', marginBottom: '20px' }}>
                                        {value.description}
                                    </p>
                                </div>

                                {/* Key takeaway / Summary Section */}
                                <div style={{
                                    padding: '12px 16px',
                                    backgroundColor: '#f8fafc',
                                    borderRadius: '8px',
                                    borderLeft: `3px solid ${value.themeColor}`
                                }}>
                                    <p style={{ margin: 0, fontSize: '0.875rem', fontWeight: '600', color: '#334155' }}>
                                        <span style={{ color: value.themeColor, fontWeight: '700' }}>Key Takeaway: </span>
                                        {value.summary}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Our Promise Section */}
                <section
                    style={{

                        padding: "50px 30px",
                        textAlign: "center",
                        marginTop: "-60px",

                    }}
                >
                    <h2
                        style={{
                            fontSize: "2rem",
                            fontWeight: "700",
                            color: "#0f172a",
                            marginBottom: "20px",
                        }}
                    >
                        Our Promise
                    </h2>

                    <p
                        style={{
                            maxWidth: "850px",
                            margin: "0 auto",
                            fontSize: "1.1rem",
                            lineHeight: "1.9",
                            color: "#475569",

                        }}
                    >
                        “Our values are more than principles they are the foundation of every
                        partnership we build, every business we grow, and every success we
                        achieve together.”
                    </p>
                </section>

                {/* Existing Components */}
                <Achievements />
                <SisterConcerms />

            </div>
        </div>
    );
};

export default OurCoreValues;